import React from 'react';
import { StatusPill } from '../../../../shared/components/patterns';
import { getDocumentStatusView } from '../library/documentsPage.config';

export default function DocumentStatusBadge({ status }) {
  const meta = getDocumentStatusView(status);
  return <StatusPill label={meta.label} tone={meta.tone} />;
}
